import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ProjectParticipant } from '../../../../data/project/project-participant';
import { Project } from '../../../../data/project/project';
import { User } from 'projects/core/src/lib/login/data/user';
import { ProjectHolder } from '../../../../interfaces/project-holder';
import { ProjectService } from '../../../../data/project/project.service';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { filter, takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-project-manager-edit',
    templateUrl: './project-manager-edit.component.html',
    styleUrls: ['./project-manager-edit.component.scss']
})
@RxJSUnsubscribe
export class ProjectManagerEditComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    managerId: number;

    manager: User;

    project: Project;

    users: User[];

  wsSub: Subscription;
    constructor(
        protected userService: UserService,
        protected projectHolder: ProjectHolder,
        private projectService: ProjectService,
        protected wsService: WsService
    ) {
        this.project = this.projectHolder.project
    }

    ngOnInit() {

    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.id === this.project.id)
            )
            .subscribe(updateInfo => {
                if (updateInfo.action === 'UPDATE' && updateInfo.entity.projectManager) {
                    this.manager = this.users.find(user => user.id === updateInfo.entity.projectManager.id)
                }
            })

        this.userService.getProjectManagers().subscribe(users => {
            users.sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            })
            this.users = users;
            this.manager = this.users.find(user => user.id === this.managerId)
        })
    }

    managerChange(event) {
        this.projectService
            .saveProject({
                id: this.project.id,
                projectManager: this.manager
            })
            .subscribe(project => {
                this.project.projectManager = project.projectManager
                this.project.participants = project.participants
                // this.manager = project.projectManager;
            })
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
